/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of format to export the image to.
 */
export enum ExportFormatType {
  ExportFormatTypeVMDK = 'vmdk',
  ExportFormatTypeQCOW2 = 'qcow2',
  ExportFormatTypeISO = 'iso',
  ExportFormatTypeQCOW2DiskContainer = 'qcow2-disk-container',
}
